/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Read/Content",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let appointmentNoteValueData = fromData.useDataValue({ viewPath,
context: 'appointment_note',
})
let eventAppointmentValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment',
})
let aggregateData = fromHelpers.isEditable(appointmentNoteValueData, eventAppointmentValueData)
let appointmentNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'appointment_note',
path: 'note',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--c-1-Z1Yf8zk': aggregateData ? "pointer" : "auto"}}
 className={`views-block ${styles.Horizontal}`}
>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 data="appointment_note.note"
 html={appointmentNoteNoteValueData}
/>
</div>
{children}
</React.Fragment>)
}